import React from 'react';
import { useParams } from 'react-router';

import { useProductQuestion, useProductSections } from '@/features/constructorProducts/hooks';
import { Question } from '@/features/constructorCommon';

export const ProductQuestion = ({ questionProp, groupId, onCreated }) => {
  const { id } = useParams();
  const { handleCreate, handleUpdate, handleDelete, isCreating, isUpdating, isDeleting } =
    useProductQuestion({ productId: id });
  const { dataSorted: dataSortedSections, loading: loadingSections, answers: dependentAnswers, setAnswers: setDependentAnswers } = useProductSections(
    id,
    questionProp ? questionProp.visibleConditions : null
  );

  return (
    <Question
      questionProp={questionProp}
      groupId={groupId}
      onCreated={onCreated}
      handleUpdate={handleUpdate}
      handleDelete={handleDelete}
      handleCreate={handleCreate}
      isCreating={isCreating}
      isUpdating={isUpdating}
      isDeleting={isDeleting}
      dataSortedSections={dataSortedSections}
      loadingSections={loadingSections}
      dependentAnswers={dependentAnswers}
      setDependentAnswers={setDependentAnswers}
      type='products'
    />
  );
};
